import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  // useParams,
  // Link,
} from "react-router-dom";

import { AuthProvider } from './Context/AuthContext';

import EmployeePrivateRoute from './Screens/EmployeePrivateRoute';
import NavigationComponent from './Components/NavigationComponent';
import EmployeeLogin from './Screens/EmployeeLogin';
import EmployeeSignup from './Screens/EmployeeSignup';
import EmployeeForgotPassword from './Screens/EmployeeForgotPassword';
import Home from './Screens/Home';
import EmployeeAdminSettings from './Screens/EmployeeAdminSettings';
import EmployeeTechSettings from './Screens/EmployeeTechSettings';
import EmployeeDefaultRateSettings from './Screens/EmployeeDefaultRateSettings';
import EmployeeFinalized from './Screens/EmployeeFinalized';
import EmployeeInvoiced from './Screens/EmployeeInvoiced';
import EmployeeDeletedItems from './Screens/EmployeeDeletedItems';
import EmployeeProfile from './Screens/EmployeeProfile';
import EmployeeThankYou from './Screens/EmployeeThankYou';
import EmployeeResetNotification from './Screens/EmployeeResetNotification';
import EmployeeEmailLists from './Screens/EmployeeEmailLists';
import EmployeeClientInformation from './Screens/EmployeeClientInformation';
import EmployeeMaintenance from './Screens/EmployeeMaintenance';
import EmployeeClientSettings from './Screens/EmployeeClientSettings';
import NewHome from './Screens/NewHome';
import Userguide from './Screens/Userguide';
import EmployeeConstruction from './Screens/EmployeeConstruction';

import ClientSignup from './Screens/ClientSignup';
import ClientLogin from './Screens/ClientLogin';
import ClientThankYou from './Screens/ClientThankYou';
import ClientForgotPassword from './Screens/ClientForgotPassword';
import ClientPrivateRoute from './Screens/ClientPrivateRoute';
import ClientHome from './Screens/ClientHome';
import ClientProfile from './Screens/ClientProfile';
import ClientService from './Screens/ClientService';
import ClientQuote from './Screens/ClientQuote';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            
            <Route exact path="/employee-login" element={ 
              <EmployeeLogin />
            } />
            <Route exact path="/employee-signup" element={ 
              <EmployeeSignup />
            } />
            <Route exact path="/employee-forgot-password" element={ 
              <EmployeeForgotPassword />
            } />
            <Route exact path="/employee-thank-you" element={
              <EmployeeThankYou />
            } />
            <Route exact path="/employee-reset-notification" element={
              <EmployeeResetNotification />
            } />
            <Route exact path="/userguide" element={
              <Userguide />
            } />
            <Route exact path="/usermanual" element={
              <Userguide />
            } />
            <Route exact path="/usermanual/:id" element={<Userguide />} />
            <Route exact path="/userguide/:id" element={<Userguide />} />


            <Route exact path="/client-signup" element={ 
              <ClientSignup />
            } />
            <Route exact path="/client-thank-you" element={ 
              <ClientThankYou />
            } />
            <Route exact path="/client-login" element={ 
              <ClientLogin />
            } />
            <Route exact path="/client-forgot-password" element={ 
              <ClientForgotPassword />
            } />

            <Route exact path="/client" element={
              <ClientPrivateRoute>
                <ClientHome />
              </ClientPrivateRoute>
            } />

            <Route exact path="/client-profile" element={
              <ClientPrivateRoute>
                <ClientProfile />
              </ClientPrivateRoute>
            } />
            <Route exact path="/client-service" element={
              <ClientPrivateRoute>
                <ClientService />
              </ClientPrivateRoute>
            } />
            <Route exact path="/client-quote" element={
              <ClientPrivateRoute>
                <ClientQuote />
              </ClientPrivateRoute>
            } />


            <Route exact path="/" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <NewHome />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/service" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <Home />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/maintenance" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeMaintenance />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/construction" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeConstruction />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/finalized" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeFinalized />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/invoiced" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeInvoiced />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/deleted-items" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeDeletedItems />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/client_information" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeClientInformation />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/admin-settings" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeAdminSettings />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/tech-settings" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeTechSettings />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/client-settings" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeClientSettings />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/rate-settings" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeDefaultRateSettings />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/employee-profile" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeProfile />
              </EmployeePrivateRoute>
            } />
            <Route exact path="/email-lists" element={
              <EmployeePrivateRoute>
                <NavigationComponent />
                <EmployeeEmailLists />
              </EmployeePrivateRoute>
            } />

          </Routes>
        </div>
      </BrowserRouter>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </AuthProvider>
  );
}

export default App;
